import React, { useContext, useEffect, useRef } from 'react'

import { DashboardContext } from 'live/context/dashboard'
import { updateSpanAndIdentity } from '../utils/RefreshFunctions'
import { refreshFunctions, SpanPickerContext } from '../utils/initialStates'

import TreeSelectFilter from './SelectFilter'

/**
 * This component works the auto loading of the dashboard (according to the span picker configs)
 *
 * @param formattedTree {Array<interventionDataTypes}- the operations tree formatted
 * @param select {TreeSelectingProps} - data related to the selection of the tree (the item selected, the function to change its selection, the timespan of the selected item and the run reference of the selected item)
 * @param check {TreeCheckingProps} - data related to the check items of the tree (data of the mainCheck, items checked, quantity of checkedOperations, and an option of using the individual timespans or the min and max of them)
 * @returns {JSX.Element} - a child that will return a JSX Element
 */

const OperationsAutoLoader = ({
    tree,
    select,
    check
}: {
    tree: TreeComponentProps
    select: TreeSelectingProps
    check?: TreeCheckingProps
}): JSX.Element => {
    const { state, ...context } = useContext(DashboardContext)
    const { operationsPickerConfigs, headerContext } = useContext(SpanPickerContext)
    const lastRunAutoLoaded = useRef(false)

    useEffect(() => {
        lastRunAutoLoaded.current = false
    }, [headerContext.hasAssetChange])

    useEffect(() => {
        if (context.params.mode === 'view') lastRunAutoLoaded.current = false
    }, [context.params.mode])

    useEffect(() => {
        if (
            !lastRunAutoLoaded.current &&
            operationsPickerConfigs.autoLoadsLastRun &&
            context.params.mode === 'view' &&
            select.selectedTimespan !== '' &&
            (operationsPickerConfigs.enableChecking ? check.checkedKeys.length > 0 : true)
        ) {
            updateSpanAndIdentity(
                operationsPickerConfigs,
                context,
                tree.formattedTree,
                select.selectedKey,
                select.selectedTimespan,
                select.selectedRunReference,
                check.checkedKeys,
                headerContext,
                refreshFunctions
            )
            lastRunAutoLoaded.current = true
        }
    }, [JSON.stringify(tree.formattedTree), context.params.mode, select.selectedTimespan, check.checkedKeys])

    return <TreeSelectFilter tree={tree} select={select} check={check} />
}

export default OperationsAutoLoader
